// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as SystemsRouteRouteImport } from './routes/systems/route'
import { Route as EnRouteRouteImport } from './routes/en/route'
import { Route as CareerRouteRouteImport } from './routes/career/route'
import { Route as BlogRouteRouteImport } from './routes/blog/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SystemsIndexRouteImport } from './routes/systems/index'
import { Route as SystemsEducationRouteImport } from './routes/systems/education'
import { Route as SystemsBplaRouteImport } from './routes/systems/bpla'
import { Route as SystemsBpakRouteImport } from './routes/systems/bpak'
import { Route as EnIndexRouteImport } from './routes/en/index'
import { Route as EnTermsRouteImport } from './routes/en/terms'
import { Route as EnPrivacyRouteImport } from './routes/en/privacy'
import { Route as EnContactsRouteImport } from './routes/en/contacts'
import { Route as EnAboutUsRouteImport } from './routes/en/about-us'
import { Route as EnSystemsRouteRouteImport } from './routes/en/systems/route'
import { Route as EnCareerRouteRouteImport } from './routes/en/career/route'
import { Route as EnBlogRouteRouteImport } from './routes/en/blog/route'
import { Route as CareerCareerIdRouteRouteImport } from './routes/career/$careerId/route'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteRouteImport } from './routes/blog/$slug/route'
import { Route as EnSystemsIndexRouteImport } from './routes/en/systems/index'
import { Route as EnSystemsEducationRouteImport } from './routes/en/systems/education'
import { Route as EnSystemsBplaRouteImport } from './routes/en/systems/bpla'
import { Route as EnSystemsBpakRouteImport } from './routes/en/systems/bpak'
import { Route as EnCareerCareerIdRouteRouteImport } from './routes/en/career/$careerId/route'
import { Route as EnBlogIndexRouteImport } from './routes/en/blog/index'
import { Route as EnBlogSlugRouteRouteImport } from './routes/en/blog/$slug/route'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ContactsRoute = ContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const SystemsRouteRoute = SystemsRouteRouteImport.update({
            id: '/systems',path: '/systems',getParentRoute: () => rootRouteImport
          })
const EnRouteRoute = EnRouteRouteImport.update({
            id: '/en',path: '/en',getParentRoute: () => rootRouteImport
          })
const CareerRouteRoute = CareerRouteRouteImport.update({
            id: '/career',path: '/career',getParentRoute: () => rootRouteImport
          })
const BlogRouteRoute = BlogRouteRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SystemsIndexRoute = SystemsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SystemsRouteRoute
          })
const SystemsEducationRoute = SystemsEducationRouteImport.update({
            id: '/education',path: '/education',getParentRoute: () => SystemsRouteRoute
          })
const SystemsBplaRoute = SystemsBplaRouteImport.update({
            id: '/bpla',path: '/bpla',getParentRoute: () => SystemsRouteRoute
          })
const SystemsBpakRoute = SystemsBpakRouteImport.update({
            id: '/bpak',path: '/bpak',getParentRoute: () => SystemsRouteRoute
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnRouteRoute
          })
const EnTermsRoute = EnTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => EnRouteRoute
          })
const EnPrivacyRoute = EnPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => EnRouteRoute
          })
const EnContactsRoute = EnContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => EnRouteRoute
          })
const EnAboutUsRoute = EnAboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => EnRouteRoute
          })
const EnSystemsRouteRoute = EnSystemsRouteRouteImport.update({
            id: '/systems',path: '/systems',getParentRoute: () => EnRouteRoute
          })
const EnCareerRouteRoute = EnCareerRouteRouteImport.update({
            id: '/career',path: '/career',getParentRoute: () => EnRouteRoute
          })
const EnBlogRouteRoute = EnBlogRouteRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => EnRouteRoute
          })
const CareerCareerIdRouteRoute = CareerCareerIdRouteRouteImport.update({
            id: '/$careerId',path: '/$careerId',getParentRoute: () => CareerRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRouteRoute
          })
const BlogSlugRouteRoute = BlogSlugRouteRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRouteRoute
          })
const EnSystemsIndexRoute = EnSystemsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnSystemsRouteRoute
          })
const EnSystemsEducationRoute = EnSystemsEducationRouteImport.update({
            id: '/education',path: '/education',getParentRoute: () => EnSystemsRouteRoute
          })
const EnSystemsBplaRoute = EnSystemsBplaRouteImport.update({
            id: '/bpla',path: '/bpla',getParentRoute: () => EnSystemsRouteRoute
          })
const EnSystemsBpakRoute = EnSystemsBpakRouteImport.update({
            id: '/bpak',path: '/bpak',getParentRoute: () => EnSystemsRouteRoute
          })
const EnCareerCareerIdRouteRoute = EnCareerCareerIdRouteRouteImport.update({
            id: '/$careerId',path: '/$careerId',getParentRoute: () => EnCareerRouteRoute
          })
const EnBlogIndexRoute = EnBlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnBlogRouteRoute
          })
const EnBlogSlugRouteRoute = EnBlogSlugRouteRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => EnBlogRouteRoute
          })





const BlogRouteRouteChildren = {
  BlogSlugRouteRoute: BlogSlugRouteRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteRouteWithChildren = BlogRouteRoute._addFileChildren(BlogRouteRouteChildren)




const CareerRouteRouteChildren = {
  CareerCareerIdRouteRoute: CareerCareerIdRouteRoute
}

const CareerRouteRouteWithChildren = CareerRouteRoute._addFileChildren(CareerRouteRouteChildren)




const EnBlogRouteRouteChildren = {
  EnBlogSlugRouteRoute: EnBlogSlugRouteRoute,EnBlogIndexRoute: EnBlogIndexRoute
}

const EnBlogRouteRouteWithChildren = EnBlogRouteRoute._addFileChildren(EnBlogRouteRouteChildren)




const EnCareerRouteRouteChildren = {
  EnCareerCareerIdRouteRoute: EnCareerCareerIdRouteRoute
}

const EnCareerRouteRouteWithChildren = EnCareerRouteRoute._addFileChildren(EnCareerRouteRouteChildren)




const EnSystemsRouteRouteChildren = {
  EnSystemsBpakRoute: EnSystemsBpakRoute,EnSystemsBplaRoute: EnSystemsBplaRoute,EnSystemsEducationRoute: EnSystemsEducationRoute,EnSystemsIndexRoute: EnSystemsIndexRoute
}

const EnSystemsRouteRouteWithChildren = EnSystemsRouteRoute._addFileChildren(EnSystemsRouteRouteChildren)



const EnRouteRouteChildren = {
  EnBlogRouteRoute: EnBlogRouteRouteWithChildren,EnCareerRouteRoute: EnCareerRouteRouteWithChildren,EnSystemsRouteRoute: EnSystemsRouteRouteWithChildren,EnAboutUsRoute: EnAboutUsRoute,EnContactsRoute: EnContactsRoute,EnPrivacyRoute: EnPrivacyRoute,EnTermsRoute: EnTermsRoute,EnIndexRoute: EnIndexRoute
}

const EnRouteRouteWithChildren = EnRouteRoute._addFileChildren(EnRouteRouteChildren)




const SystemsRouteRouteChildren = {
  SystemsBpakRoute: SystemsBpakRoute,SystemsBplaRoute: SystemsBplaRoute,SystemsEducationRoute: SystemsEducationRoute,SystemsIndexRoute: SystemsIndexRoute
}

const SystemsRouteRouteWithChildren = SystemsRouteRoute._addFileChildren(SystemsRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BlogRouteRoute: BlogRouteRouteWithChildren,CareerRouteRoute: CareerRouteRouteWithChildren,EnRouteRoute: EnRouteRouteWithChildren,SystemsRouteRoute: SystemsRouteRouteWithChildren,AboutUsRoute: AboutUsRoute,ContactsRoute: ContactsRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)